module.exports = __webpack_public_path__ + "img/ArgIslan6.870ed8c6.jpg";